module.exports = "<div class=\"yeti-tabs\">\r\n    <menu class=\"yeti-tab-menu\">\r\n        <li \r\n            *ngFor=\"let item of tabItems\"\r\n            (click)=\"changeTab(item)\"\r\n            [class.active]=\"item == currentTabItem\">\r\n            {{item.tabHeader}}\r\n            <span *ngIf = \"item.isInvalid\" class=\"invalid\">\r\n                <i class=\"yeti-icon-error\"></i>\r\n            </span>\r\n        </li>\r\n    </menu>\r\n    <div class=\"yeti-tab-container\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reusable-components/tab-menu/tab-host.html
// module id = 677
// module chunks = 0